import { render, staticRenderFns } from "./release-confirm.vue?vue&type=template&id=d7065faa&scoped=true&"
import script from "./release-confirm.vue?vue&type=script&lang=js&"
export * from "./release-confirm.vue?vue&type=script&lang=js&"
import style0 from "./release-confirm.vue?vue&type=style&index=0&id=d7065faa&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d7065faa",
  null
  
)

export default component.exports